import Axios from "axios";

// *base url to make request to database
const baseURL = "https://vibecorner.com.hk/index.php/api/";

// const baseURL = "http://127.0.0.1:8000/api/";

const instance = Axios.create({
  baseURL: baseURL,
  headers: {
    "Content-type": "multipart/form-data",
  },
});
export default instance;
